/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-03-05 15:18:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-11-24 15:47:16
 * @FilePath: /src/utils/enums/order.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { env } from '@/utils/env';

/**
 * 订单状态枚举
 * @enum {string}
 */
export enum EOrderStatus {
  /** 配送中 */
  DELIVERY = 'delivery',
  /** 已关闭 */
  CLOSED = 'closed',
  /** 已发货 */
  SHIPPED = 'shipped',
  /** 处理中 */
  PROCESSING = 'processing',
  /** 未支付 */
  UNPAID = 'unpaid',
}

/**
 * 订单列表Tab类型
 */
export enum EOrderTabStatus {
  /** 全部 */
  ALL = '',
  /** 未支付 */
  UNPAID = 1,
  /** 处理中 */
  PROCESSING = 2,
  /** 已发货 */
  SHIPPED = 3,
  /** 已配送 */
  DELIVERY = 4,
  /** 已关闭 */
  CLOSED = 5,
}

/**
 * 订单类型
 */
export enum EOrderType {
  /** 普通订单 */
  NORMAL = 1,
  /** 批发订单 */
  WHOLESALE = 2,
  /** 网红订单 */
  INFLUENCER = 3,
  /** 补发单 */
  REISSUE = 4,
  REISSUE_2 = 12,
  /** 积分商城 */
  POINTS_MALL = 14,
}

/**
 * 配送方式枚举
 * @enum {string}
 */
export enum EShippingMethod {
  /** 标准配送 */
  ORDINARY = 'ordinary',
  /** 高级配送 */
  ADVANCED = 'advanced',
  /** 商务快递 */
  BUSINESS = 'business',
}
/**
 * 配送方式显示名称
 * @enum {string}
 */
export const EShippingMethodDisplayName = (method: EShippingMethod, t: (key: string) => string) => {
  switch (method) {
    case EShippingMethod.ORDINARY:
      return t('ordinary');
    case EShippingMethod.ADVANCED:
      return t('advanced');
    case EShippingMethod.BUSINESS:
      return t('business');
    default:
      return method;
  }
};
/**
 * 支付中台支付方式接口返回的 payment_method 字段
 */
export enum EPaymentMethod {
  /** paypal */
  PAYPAL = 'paypal',
  /** 信用卡 */
  CARD = 'card',
  /** 钱包 */
  WALLET = 'wallet',
  /** klarna */
  KLARNA = 'klarna',
  /** afterpay */
  AFTERPAY = 'afterpay',
  /** googlepay */
  GOOGLEPAY = 'googlepay',
  /** applepay */
  APPLEPAY = 'applepay',
  /** skip */
  SKIP = 'skip',
}

/**
 * 支付方式显示名称
 */

const cardDisplayName =
  env.NEXT_PUBLIC_SITE_NAME === 'fr' ? 'Carte bancaire' : 'Credit / Debit Card';

export const EPaymentMethodDisplayName = Object.freeze({
  [EPaymentMethod.PAYPAL]: 'PayPal',
  [EPaymentMethod.CARD]: cardDisplayName,
  [EPaymentMethod.WALLET]: 'Store Credit',
  [EPaymentMethod.KLARNA]: 'Klarna',
  [EPaymentMethod.AFTERPAY]: 'Afterpay',
  [EPaymentMethod.GOOGLEPAY]: 'Google Pay',
  [EPaymentMethod.APPLEPAY]: 'Apple Pay',
  [EPaymentMethod.SKIP]: 'Skip',

  // 兼容老数据
  adyen: cardDisplayName,
  paypal_express: 'PayPal',
  useepay_card: cardDisplayName,
  klarna_adyen: 'Klarna',
});
